import * as _ from 'lodash';

export function isSearchQueryValid(query: string): boolean {
    return !_.isEmpty(prepareSearchQuery(query));
}

export function prepareSearchQuery(query: string): string {
    return _.trim(query);
}

export function searchQueryWithinLength(query: string, minLength: number, maxLength: number): string | null {
    const normalized = query.trim();

    if (normalized.length < minLength || normalized.length > maxLength) {
        return null;
    }

    return normalized;
}
